import { Component } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';

@Component({
  selector: 'compute-vc',
  template: require('./compute-vc.html')
})
export default class ComputeVC {
  constructor(private translateService: TranslateService) {
    translateService.use(GlobalVariables.LOCALE);
  }
  ngOnInit() {
    console.log('init compute-vc component');
  }
};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vc/compute-vc.component.ts